export default "__VITE_ASSET__C1kc0KUN__"